// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bik_h bik_kh bik_we bik_su bik_vt bik_sw bik_sn"};